module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.content.title,
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Contenu de la facture"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Société émettrice"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "value": 1,
      "placeholder": "Select"
    }
  }, [_c('el-option', {
    key: 1,
    attrs: {
      "label": "Com Web",
      "value": 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Société réceptrice"
    }
  }, [_c('customer-select', {
    attrs: {
      "id": _vm.item.customer_id
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "100px 0"
    }
  }, [_vm._v("Détail de la facture")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "offset": 16,
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amount_total_no_vat",
      "label": "Total HT"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.amount_total_no_vat),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount_total_no_vat", $$v)
      },
      expression: "form.amount_total_no_vat"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("€ HT")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "amount_total",
      "label": "Total TTC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.amount_total),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount_total", $$v)
      },
      expression: "form.amount_total"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("€ TTC")])], 2)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Options de facture"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "user_id",
      "label": "Interlocuteur"
    }
  }, [_c('user-select', {
    attrs: {
      "id": _vm.form.user_id
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deadline_at",
      "label": "Date limite de paiement"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Choisissez une date"
    },
    model: {
      value: (_vm.form.deadline_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "deadline_at", $$v)
      },
      expression: "form.deadline_at"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "litigation_at",
      "label": "Date limite de recouvrement"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Choisissez une date"
    },
    model: {
      value: (_vm.form.litigation_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "litigation_at", $$v)
      },
      expression: "form.litigation_at"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.content.button_type,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submit(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.button))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61e640f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/InvoiceModal.vue
// module id = 700
// module chunks = 1